<div #AssetViewerContainer class="asset-viewer-container">
  <app-generic-toolbar
    [toolbarOptions]="toolbarOptions"
  >
    <div
      _ti_embed-menu-container="embed-menu-container"
      class="embed-menu-container"
      #ShareDropdownContainer
    >
      <button (click)="share()">Share data workbook</button>
      <button (click)="shareWithParameters()">Share active tab (with filters)</button>
    </div>
  </app-generic-toolbar>

  <app-quicksight-display
    [embedUrl]="dashboardUrl"
    [dashboardOptions]="dashboardInitialState"
    (dashboardLoaded)="setDashboardLoaded($event)"
    (sheetChanged)="sendTabViewTelemetryEvent($event)"
  ></app-quicksight-display>
</div>

<div *ngIf="isLoading" class="loading-indicator">
  <app-progress-bar-circular></app-progress-bar-circular>
</div>
